import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    awsUrl: null
};

export const EnumsSlice = createSlice({
    name: "EnumsSlice",
    initialState,
    reducers: {

        setAwsUrlEnum: (state, { payload }) => {
            state.awsUrl = payload;
        },

    },
});

export const { setAwsUrlEnum } = EnumsSlice.actions;
export default EnumsSlice.reducer;
